import { Modal } from './Modal.jsx';
import { useId } from 'react';

// Used only for genuinely destructive/hard-to-undo actions (spec §40) —
// archiving a menu/category/item, deleting an option value, disabling an
// admin. Everyday actions never go through this.
export function ConfirmDialog({ title, description, confirmLabel = 'Confirm', danger = true, onConfirm, onCancel, busy = false, error = null }) {
  const titleId = useId();
  const descriptionId = useId();
  return (
    <Modal onClose={onCancel} role="alertdialog" labelledBy={titleId} describedBy={description ? descriptionId : undefined} busy={busy}>
      <h2 id={titleId}>{title}</h2>
      {description && <p id={descriptionId}>{description}</p>}
      {error && <p className="field-error" role="alert">{error}</p>}
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
        <button type="button" className="btn" onClick={onCancel} disabled={busy}>
          Cancel
        </button>
        <button type="button" className={danger ? 'btn btn-danger' : 'btn btn-primary'} onClick={onConfirm} disabled={busy} aria-busy={busy || undefined}>
          {busy ? `${confirmLabel}…` : confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
